import React from 'react';
import TrainingPage from '../components/training/TrainingPage';
import trainingContent from '../config/trainingContent';

export default function CopilotManufacturingTraining() {
  return (
    <TrainingPage
      seo={{
        title: "Microsoft Copilot Training for Manufacturing Teams | Eagentix",
        description: "1-day onsite Microsoft Copilot training for operations, quality and supply chain teams. Hands-on with your own production and quality records — shift reporting, deviation write-ups, supplier correspondence."
      }}
      content={trainingContent.manufacturing}
    />
  );
}
